<template>
  <div>
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="search-box">
      <!-- style="background-color:red;border-color:red;color:#fff;" -->
      <van-field
        size="small"
        v-model="scanskuCode"
        placeholder="请扫描SKU"
        right-icon="scan"
        clear-trigger="always"
        clearable
        @click-right-icon="scanSku"
        @keyup.13="getList()"
        @input="triggerSearch"
        @keyup="inputNum"
        ref="scanInp"
      />
    </div>

    <div class="search-box">
      <!-- style="background-color:red;border-color:red;color:#fff;" -->
      <!-- <van-field
        size="small"
        v-model="scanLocationCode"
        placeholder="请输入新库位"
        right-icon="scan"
        clear-trigger="always"
        clearable
        @click-right-icon="scanSku"
        @keyup.13="getLocation()"
        @input="triggerSearch"
        @keyup="inputNum"
        ref="scanInp"
      />
      <button class="hidden" ref="searchBtn" @click="getLocation()"></button>
      <span style="font-size: 14px; color: red" v-if="showErrStr.length">{{
        showErrStr
      }}</span>
      <span style="font-size: 14px; color: green" v-if="successStr.length">{{
        successStr
      }}</span> -->

      <div>
          <van-field
            size="small"
            v-model="scanLocationCode"
            placeholder="请输入新库位"
            right-icon="scan"
            @click-right-icon="scanSku"
            @focus="storageFocus"
            @input="storageChange"
            ref="storage"
          />
        </div>

    </div>

    <div class="list">
      <van-row type="flex" justify="center" align="center">
        <van-col span="8">库位</van-col>
        <van-col span="8">库存数</van-col>
        <van-col span="8">移库数({{this.countchangeNum}})</van-col>
      </van-row>
      <div>
        <van-swipe-cell
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="list-div" @click="openModel(item.locationCode)">
            <p>{{ item.locationCode }}</p>
            <p>{{ item.enableQty }}</p>

            <p>
              <input
                type="number"
                class="downInp"
                readonly
                v-model="item.changeNum"
              />
            </p>
          </div>
          <template #right>
            <van-button
              square
              type="danger"
              text="清零"
              @click="toDelete(index)"
            />
          </template>
        </van-swipe-cell>
      </div>
      <div class="submit-box">
        <p><button class="submit-btn" @click="submit">确认提交</button></p>
      </div>
    </div>

    <van-dialog
      v-model="show"
      :title="`库位 ${saveLocationCode}`"
      show-cancel-button
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="confirm"
    >
      <div style="padding: 5% 20%">
        <van-field
          type="digit"
          size="small"
          placeholder="请输入SKU数量"
          v-model="saveNum"
        />
      </div>
    </van-dialog>
  
  <van-popup v-model="showPicker" round position="bottom" :overlay="false">
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :loading="loading"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
} from "vant";
import {
  LablechangeCheckStorageAndStock,
  InventoryChangeFinishSubmit,
} from "@/api/mobile/changelabel_api";
import{
  getProductInventory
} from "@/api/mobile/inventory_api";
import { getWarehouseLocation } from "@/api/mobile/stock_api";
import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      list: {},
      scanLocationCode: "",
      scanskuCode: "",
      show: false,
      saveLocationCode: "",
      saveNum: "",
      refuseReason: "",
      showErrStr: "",
      isAutoOpen: false,
      successStr: "",
      scanskuStorageCommon: {},
	   newskuStorageCommonList: [],
     countchangeNum:0,
     totle:0,
     showPicker: false,
     columns: [],
     loading: false,
     focusType: "",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  mounted() {
    // document.querySelector('.van-field__right-icon').style.color = '#ffffff'
    // document.querySelector('.van-field__control').style.color = '#ffffff'
  },
  methods: {
    ...mapMutations({
      saveMobileTitle: "saveMobileTitle",
    }),

    init() {
      this.saveMobileTitle(window.localStorage.mobileTitle);
      //this.getList();
    },
    // 库位获取焦点
    storageFocus() {
      this.showPicker = true;
      this.focusType = "storageName";
      this.storageChange();
    },

     storageChange() {
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      const { warehouseId } = _warehouse;
      if (!this.scanLocationCode) return;

      const data = { locationCode: this.scanLocationCode, warehouseId };
      this.loading = true;

      getWarehouseLocation(data).then((res) => {
        this.loading = false;
        if (res.status === 200) {
          const { response } = res;

          try {
            let arr = [];
            response.forEach((item) => {
              arr.push(item.locationCode);
            });
            this.columns = arr;
          } catch {}
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    onConfirm(val) {
      this.scanLocationCode=val;
      this.showPicker = false;
    },
    triggerSearch() {
    },

    getList() {
      const that = this;
      this.showErrStr = "";
      this.successStr = "";
       const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      const data = {
        sku:this.scanskuCode,
        warehouseId:_warehouse.warehouseId
      };

      getProductInventory(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;
          console.info(response);
          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    openModel(code) {
      this.show = !this.show;
      this.saveLocationCode = code;
      this.isAutoOpen = false;
      this.successStr = "";
    },
    
    confirm() {

      this.list.forEach((item, i) => {
        if (item.locationCode === this.saveLocationCode) {
          if (this.saveNum > item.totalQty) {
            Toast("转化数不可大于库存数");
            this.saveNum = 0;
          }
          this.$set(
            this.list[i],
            "changeNum",
            this.saveNum || 0
          );
        }
      });
      const s = this.saveNum;
      if (this.isAutoOpen) {
        this.showErrStr = "";
        this.successStr = `库位 ${this.saveLocationCode} 扫入成功，数量${s}`;
      }
      this.saveNum = "";
   
    var arr2=[];
    this.list.forEach((item, index) => {
          if (item.changeNum) {
             arr2.push(item.changeNum);  
          };
      });
    this.countchangeNum = arr2.reduce((prev, cur) => Number(prev) + Number(cur));
     
    },

    toDelete(i) {
      this.countchangeNum=this.countchangeNum-this.list[i].changeNum;
      this.$set(this.list[i], "changeNum", 0);
   
      

    },
 showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() 
    {
      const that = this;
      console.info(this.list.length);
      if(this.list.length==undefined)
      {
        this.showsound(false);
        Toast.fail('请输入SKU后回车');
        return;
      }
      if(this.scanLocationCode=='')
      {
        this.showsound(false);
        Toast.fail('请输入新库位');
        return;
      }
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      const warehouseID = _warehouse.warehouseId;
      let skuStorageList = [];
      this.list.forEach((item, index) => {
        if (item.changeNum) {
          const { locationCode, storageID, changeNum } = item;
          var _item = {
            locationCode: locationCode,
            storageID: storageID,
            changeNum: changeNum,
          };
          skuStorageList.push(_item);
        }
      });
      if(skuStorageList.length==0)
      {
        this.showsound(false);
        Toast.fail('请在旧库位录入移库数量');
        return;
      }
      const data = {
        WarehouseID:warehouseID,
        NewLocationCode: this.scanLocationCode,
        SKU: this.scanskuCode,
        SkuStorageList: skuStorageList,
      };
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      InventoryChangeFinishSubmit(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.showsound(true);
          this.successStr = "";
          this.showErrStr = "";
          Toast.success(res.msg);
          this.getList();
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.scanLocationCode = a.resultStr;
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    .item-li {
      display: flex;
      align-content: flex-start;
      & > div {
        white-space: nowrap;
        word-break: break-all;
        flex: 1;
        line-height: 25px;
        & > span {
          vertical-align: text-top;
          &:first-child {
            padding-right: 10px;
            width: 50%;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
.submit-box {
  position: static;
  margin: 20px 0;
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
  position: static;
  bottom: 2%;
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
}
.search-box {
  text-align: center;
  padding: 3% 12% 1.5%;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
.list {
  .list-div {
    display: flex;
    height: 43px;
    line-height: 43px;
    border-bottom: 1px solid #ccc;
    & > p {
      flex: 1;
      text-align: center;
      margin: 0;
      & > .downInp {
        width: 55%;
        border: 1px solid #ccc;
        height: 25px;
        line-height: 25px;
        text-align: center;
      }
    }
  }
}
.sign-photo-save {
  padding: 0 10px;
}
.photo {
  font-size: 14px;
}
</style>